import { type CoreBundleItemPayload, type CoreProduct } from '@flecto/types'
import { useModal } from '@flecto/ui'

import { ModalBundleItemsSelection } from '../components/ModalBundleItemsSelection/ModalBundleItemsSelection'

type UseModalBundleItemsSelectionProps = {
  handleItemsUpdate?: (
    items: Array<
      CoreProduct & {
        quantity: number
      }
    >
  ) => void
  itemsInBundle?: Array<CoreBundleItemPayload>
}

export function useModalBundleItemsSelection() {
  return useModal<UseModalBundleItemsSelectionProps>({
    modalComponent: (props) => (
      <ModalBundleItemsSelection
        itemsInBundle={props?.itemsInBundle}
        handleItemsUpdate={props?.handleItemsUpdate}
      />
    ),
  })
}
